<form [formGroup]="menuService?.form" (ngSubmit)="saveAndContinue()" class="px-0 px-sm-3"
    [ngClass]="{ 'py-5 position-relative': isDialog }">
    <div class="container-fluid">
        <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" *ngIf="isDialog"
            (click)="dialogRef.close()"></i>
        <h4 *ngIf="isDialog" class="text-bold text-center px-3">
            Vehículo {{menuService.isSatelliteLockService() ? ' a seguir' : ' y conductor a escoltar'}}
        </h4>
        <div class="row" *ngIf="canViewEscortedVehicle">

            <p class="col-12 my-3 text-bold">
                Vehículo {{menuService.isSatelliteLockService() ? ' a seguir' : ' y conductor a escoltar'}}
            </p>
            <!-- License Plate -->
            <mat-form-field appearance="outline" class="col-12">
                <mat-label>Placa del vehículo<span class="asterisk">*</span></mat-label>
                <input matInput appLicensePlate type="text" [formControl]="licensePlateControl">
                <mat-error *ngIf="licensePlateControl.errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                </mat-error>
            </mat-form-field>
            <!-- Vehicle Type -->
            <app-type-vehicle class="col-md-6" [inputFormControl]="vehicleTypeControl" [options]="optionsTypeVehicle"
                [validate]="formValidate">
            </app-type-vehicle>
            <!-- Container Number -->
            <mat-form-field appearance="outline" class="col-md-6 mb-3">
                <mat-label>N° de Contenedor<span class="optional">(solo si aplica)</span></mat-label>
                <input matInput type="text" [formControl]="containerNumberControl" angularFormsMask="CCCCDDDDDDD"
                    containerNumber>
                <mat-error *ngIf="containerNumberControl.errors?.pattern">
                    {{utils.giveMessageError('INVALID_CONTAINER_GENERAL') }}
                </mat-error>
            </mat-form-field>
            <!-- Brand -->
            <mat-form-field appearance="outline" class="col-md-6">
                <mat-label>Marca del vehículo<span class="optional">(opcional)</span></mat-label>
                <input matInput type="text" [formControl]="brandControl">
            </mat-form-field>
            <!-- Color -->
            <mat-form-field appearance="outline" class="col-md-6">
                <mat-label>Color del vehículo<span class="optional">(opcional)</span></mat-label>
                <input matInput type="text" [formControl]="colorControl">
            </mat-form-field>
            <!-- Document Type -->
            <mat-form-field appearance="outline" class="col-md-6">
                <mat-label>Tipo de identificación del conductor<span class="optional">(opcional)</span></mat-label>
                <mat-select [formControl]="documentTypeDriverControl" name="documentType"
                    [compareWith]="compareDocumentTypes">
                    <mat-option *ngFor="let documentType of documentTypes" [value]="documentType">
                        {{documentType.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <!-- Document -->
            <mat-form-field appearance="outline" class="col-md-6">
                <mat-label>Documento del conductor<span class="optional">(opcional)</span></mat-label>
                <ng-container [ngSwitch]="enableOnlyNumbers">
                    <input matInput onlyNumbersInt type="text" [formControl]="documentDriverControl"
                        *ngSwitchCase="true">
                    <input matInput numbersAndMayus type="text" [formControl]="documentDriverControl"
                        *ngSwitchCase="false">
                </ng-container>
            </mat-form-field>
            <!-- Name -->
            <mat-form-field appearance="outline" class="col-md-6">
                <mat-label>Nombre del conductor<span class="optional">(opcional)</span></mat-label>
                <input matInput type="text" [formControl]="nameDriverControl">

            </mat-form-field>
            <!-- Phone Number -->
            <mat-form-field appearance="outline" class="col-md-6">
                <mat-label>Celular del conductor<span class="optional">(opcional)</span></mat-label>
                <input matInput onlyNumbersInt type="text" [formControl]="phoneNumberDriverControl" [maxlength]="10">
                <mat-error *ngIf="phoneNumberDriverControl.errors?.maxlength">
                    {{ utils.giveMessageError('MAX_LENGTH_EXCEED', 'celular', 10) }}
                </mat-error>
            </mat-form-field>
        </div>
        <div *ngIf="!canViewEscortedVehicle" class="no-permission-container">
            <i class="fas fa-exclamation-circle fa-lg m-2"></i>
            <h4 class="text-bold">No tienes permiso para acceder a esta información. Contacta a tu administrador para
                solicitar acceso.</h4>
        </div>
        <div class="button-container mt-4" *ngIf="!isDialog; else dialogButtons">
            <button mat-raised-button color="primary" class="button-width-auto primary-secondary button-small"
                [ngClass]="{'warn': true}" type="button" (click)="backToPreviousStep()">
                <span class="mat-button-wrapper">Atras</span>
            </button>
            <button class="mx-2" type="submit" mat-raised-button color="accent" *ngIf="canEditEscortedVehicle">
                Guardar y Continuar
            </button>
            <button class="mx-2" type="button" mat-raised-button color="accent" (click)="continueToNextStep()"
                *ngIf="!canEditEscortedVehicle">
                Continuar
            </button>
        </div>
        <ng-template #dialogButtons>
            <div class="button-container mt-4">
                <button class="mx-2" type="submit" mat-raised-button color="accent">
                    Guardar
                </button>
            </div>
        </ng-template>
    </div>
</form>